import { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import DivixLogo from "../assets/img/divixNegro.png";
import { getAzulResponseParams, AzulPaymentResponse } from "../services/dtos/response/AzulResponseDto";
import TipService from "../services/TipService";
import UserService from "../services/UserService";
import { GetEmployeeResponseDto } from "../services/dtos/response/UserResponseDto";
import { UpdateTipStatusDto } from "../services/dtos/request/UpdateTipStatusDto";
import { TipStatus } from "../services/dtos/TipStatus";

export function PaymentDeclinedPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userIdFromUrl = params.get("userId");
  const branchIdFromUrl = params.get("branchId");
  
  const [azulResponse, setAzulResponse] = useState<AzulPaymentResponse | null>(null);
  const [employee, setEmployee] = useState<GetEmployeeResponseDto | null>(null);
  const [tipStatusUpdated, setTipStatusUpdated] = useState(false);
  const tipService = useMemo(() => new TipService(), []);
  const userService = useMemo(() => new UserService(), []);

  // Capturar respuesta de Azul al cargar la página
  useEffect(() => {
    const responseParams = getAzulResponseParams();
    
    if (Object.keys(responseParams).length > 0) {
      setAzulResponse(responseParams);
    }
  }, [tipService]);

  // Actualizar status del tip a DECLINADA si hay tipId (se ejecuta cuando employee está disponible)
  useEffect(() => {
    if (tipStatusUpdated) {
      return;
    }

    if (!employee) {
      return;
    }

    // Obtener tipId de sessionStorage (guardado antes de redirigir a Azul)
    const tipIdFromStorage = sessionStorage.getItem('azulTipId');
    
    if (tipIdFromStorage) {
      const tipId = parseInt(tipIdFromStorage, 10);
      
      if (isNaN(tipId)) {
        console.error("[AZUL] tipId no es un número válido:", tipIdFromStorage);
        return;
      }
      
      setTipStatusUpdated(true);
      
      const responseParams = getAzulResponseParams();
      const updateData = new UpdateTipStatusDto();
      updateData.TipId = tipId;
      updateData.Status = TipStatus.DECLINADA;
      
      if (responseParams.AzulOrderId) {
        updateData.AzulOrderId = responseParams.AzulOrderId;
      }
      
      if (employee?.countryIsoCode) {
        updateData.CountryCode = employee.countryIsoCode.toUpperCase();
      }
      
      tipService.updateStatusTipInProcess(
        updateData,
        () => {},
        (errorMessage) => {
          console.error("[AZUL] Error al actualizar status:", errorMessage);
        }
      );
    }
  }, [tipService, employee, tipStatusUpdated]);

  // Obtener employee para poder incluir CountryCode
  useEffect(() => {
    const fetchEmployee = async () => {
      if (!userIdFromUrl) return;
      
      try {
        await userService.getEmployee(
          {
            userid: +userIdFromUrl,
            branchid: +branchIdFromUrl!,
          },
          (data) => {
            setEmployee(data);
          },
          () => {}
        );
      } catch (error) {
        // Error silencioso
      }
    };

    if (userIdFromUrl && branchIdFromUrl) {
      fetchEmployee();
    }
  }, [userService, userIdFromUrl, branchIdFromUrl]);

  return (
    <div className="flex flex-col min-h-screen">
      <div 
        className="h-56 flex items-center justify-center pt-20"
        style={{
          backgroundColor: "#e0e0e0",
        }}
      >
        <img 
          className="mx-auto"
          style={{
            maxWidth: '180px',
            maxHeight: '90px',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain'
          }}
          src={DivixLogo} 
          alt="Logo" 
        />
      </div>
      <div className="text-center mt-12 mx-auto max-w-md px-4">
        <h1 
          className="text-5xl mb-4"
          style={{
            color: "#3a3a3a",
          }}
        >
          Pago Declinado
        </h1>
        <div className="max-w-60 mx-auto pt-2 pb-10">
          <span 
            className="text-xl text-center"
            style={{
              color: "#3a3a3a",
            }}
          >
            El pago no pudo ser procesado. Por favor, intente nuevamente.
          </span>
        </div>
        <a
          className="text-white inline-flex mb-4 bg-primary rounded-full py-1 px-3"
          href="https://www.divix.net"
        >
          www.divix.net
        </a>
      </div>
    </div>
  );
}

